import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('LeagueDivisionUser')
export class LeagueDivisionUser {

  @JsonProperty('user_id', Number)
  userId: number = 0;

  @JsonProperty('user_displayname', String)
  userDisplayname: string = '';

  @JsonProperty('is_active', Boolean)
  isActive: boolean = false;

  @JsonProperty('game', Number)
  game: number = 0;

  @JsonProperty('point', Number)
  point: number = 0;

  @JsonProperty('is_reward_granted', Boolean)
  isRewardGranted: boolean = false;
}
